import React, { useEffect, useState } from 'react';
import ApiService from '../services/api-service';
import LocalNews from '../ui/local-news/local-news';
import Button from '../ui/shared/button';
import mockNews from '../mocks/local-news.json';
import { CalendarIcon, NewspaperIcon, ArrowCircleRight, ArrowCircleDown } from '../ui/shared/icons';
import { NEWS_FALLBACK_BANNER } from '../ui/shared/assets';
import './css/read-news.css';

const linkRenderer = (button) => {
    return <a href={button.linkPath} key={button.id} target="_blank">
        <Button type="text" icon={ArrowCircleRight}>{button.label}</Button>
    </a>
}

const attachmentRender = (attachment) => {
    return <>
        <br />
        <a href={attachment.details?.url} key={attachment.id} target="_blank">
            <Button icon={ArrowCircleDown}>
                {attachment.title || attachment.details?.fileName}
                <br />
                <small>{attachment.details?.contentType}</small>
            </Button>
        </a>
    </>
}

export default ({ match }) => {
    const [news, setNews] = useState([]);
    const newsItem = news.find(item => item.id === match.params.id);

    useEffect(async () => {
        try {
            const response = await ApiService.get('news');
            setNews(response);
        } catch (exception) {
            console.log(exception);
        }
    }, []);

    if(!newsItem) {
        return <></>;
    }
    return <>
        <article>
            <div className="row row-bg-dark">
                <div className="read-news-header">
                    <h2>{newsItem.heading}</h2>
                    <h4>{newsItem.subHeading}</h4>
                    <div className="news-post-meta">
                        <span><NewspaperIcon />{newsItem.source}</span>
                        <span><CalendarIcon />{newsItem.datePosted}</span>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="flex-col flex-container read-news-content-container">
                    <div>
                        <div className="banner-image-container">
                            <img src={newsItem.bannerImage || NEWS_FALLBACK_BANNER } />
                        </div>
                        <div className="attachment-container">
                            {newsItem.attachments && newsItem.attachments.map(attachment => attachmentRender(attachment))}
                        </div>
                        <span className="read-news-content" dangerouslySetInnerHTML={{ __html: newsItem.content }} />
                    </div>
                    <div>
                        {newsItem.buttons && newsItem.buttons.map(button => linkRenderer(button))}
                    </div>
                </div>
            </div>
        </article>
        <LocalNews news={mockNews} heading="Other News" />
    </>
}